.tile {
    font-size: 14px;
    max-width: 50px;
    width: 100%;
    margin: 1px;
    perspective: 1000px;
    user-select: none;
    .tileInside {
        padding-top: 100%;
        width: 100%;
        transition: 0.25s;
        transform-style: preserve-3d;
        position: relative;
        border-radius: 5%;
        -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
        &:focus {
            outline: none;
            box-shadow: none;
        }
    }
    .front,
    .back {
        display: flex;
        height: 100%;
        width: 100%;
        padding: 0;
        border: 0;
        background: transparent;
        color: inherit;
        font: inherit;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        left: 0;
        backface-visibility: hidden;
        appearance: none;
        > span {
            pointer-events: none;
        }
        &:focus-visible {
            outline: 2px solid var(--secondary-light);
            outline-offset: -2px;
        }
    }
    .front {
        transform: rotateY(0deg);
    }
    .back {
        transform: rotateY(180deg);
    }
    &.inactive {
        visibility: hidden;
    }
    &.disabled {
        .tileInside {
            pointer-events: none;
            transition: none !important;
        }
    }
    &.active {
        .tileInside {
            background-color: var(--primary);
            color: var(--primary);
            cursor: pointer;
            @media (hover: hover) {
                &:hover {
                    background-color: var(--primary-light);
                    color: var(--secondary);
                }
            }
        }
    }
    &.flipped {
        .tileInside {
            transform: rotateY(180deg);
            background-color: var(--secondary);
            color: var(--secondary);
            cursor: pointer;
            @media (hover: hover) {
                &:hover {
                    background-color: var(--secondary-light);
                    color: var(--primary);
                }
            }
        }
    }
    &.coords {
        .front {
            background-color: transparent;
        }
        .back {
            visibility: hidden;
        }
    }
}
